import { IApplicationState } from '../../types/redux';

export const selectIsCianAuthorized = (state: IApplicationState): boolean => state.calculator.user.isCianAuthorized;
